import { createSlice } from '@reduxjs/toolkit';
import { Notification } from '@iqmaxx/shared';

interface NotificationsState {
  notifications: Notification[];
  loading: boolean;
  error: string | null;
}

const initialState: NotificationsState = {
  notifications: [],
  loading: false,
  error: null,
};

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    // Add notification reducers here
  },
});

export default notificationsSlice.reducer;
